import React from 'react';
import useSectionView from '../../hooks/useSectionView';

const STEPS = [
  {
    num: '01',
    title: 'Enter your income',
    desc: 'Tell us what you made last year — hail season and all. Takes 30 seconds.',
  },
  {
    num: '02',
    title: 'See your tax reserve',
    desc: 'We estimate SE tax, federal, and state to get your recommended quarterly reserve, instantly.',
  },
  {
    num: '03',
    title: 'Pay the IRS yourself, guided',
    desc: 'A step-by-step guide through IRS Direct Pay. You pay the IRS directly — we just make it simple.',
  },
];

function HowItWorks() {
  const sectionRef = useSectionView('section_viewed_how_it_works');
  return (
    <section ref={sectionRef} style={{ backgroundColor: 'var(--paper)', padding: '96px 24px' }}>
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
        <h2 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: '36px',
          color: 'var(--ink)',
          textAlign: 'center',
          margin: '0 0 56px 0',
        }}>
          How TruFlow works
        </h2>

        <div className="hw-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
        }}>
          {STEPS.map((step) => (
            <div key={step.num} style={{
              backgroundColor: 'var(--card)',
              borderRadius: '14px',
              padding: '32px',
              boxShadow: 'var(--sh-card)',
            }}>
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                backgroundColor: 'var(--signal-soft)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
              }}>
                <span style={{
                  fontFamily: 'var(--font-sans)',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: 'var(--signal)',
                }}>
                  {step.num}
                </span>
              </div>
              <h3 style={{
                fontFamily: 'var(--font-serif)',
                fontSize: '20px',
                color: 'var(--ink)',
                margin: '0 0 12px 0',
              }}>
                {step.title}
              </h3>
              <p style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '15px',
                color: 'var(--slate)',
                lineHeight: 1.6,
                margin: 0,
              }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .hw-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}

export default HowItWorks;
